import { useEffect, useState } from "react";
import { CheckIcon, Cross1Icon } from "@radix-ui/react-icons";
import { Card } from "../../Components/ui/card"; // Assuming you're using Shadcn's Card component
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../Components/ui/dialog";
import { Button } from "../../Components/ui/button";
import { toast, useToast } from "../../Components/ui/use-toast";
import { Toaster } from "../../Components/ui/toaster";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";

interface CheckedChannel {
  channelId: number;
  channelName: string;
}

const OperatorChannelList = () => {
  const [selectedChannel, setSelectedChannel] = useState<string>("");

  const [channels, setChannels] = useState<
    { channel_id: number; channel_name: string; channel_description: string }[]
  >([]);

  const navigate = useNavigate();
  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id
  );
  const apiUrlAdminAcc = useSelector(
    (state: RootState) => state.authentication.adminUrl
  );

  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL
  );
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id
  );
  const workspaceName = useSelector(
    (state: RootState) => state.authentication.workspaceName
  );
  const emailId = useSelector(
    (state: RootState) => state.authentication.userEmail
  );

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isdialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const [checkedChannels, setCheckedChannels] = useState<CheckedChannel[]>([]);
  const toast = useToast();
  useEffect(() => {
    console.log("AdminUrl :", apiUrlAdminAcc);
    console.log("AcoountId :", accountId);
    console.log("WorkspaceId :", workspaceId);

    GetChannelList();
    GetOperatorChannelsListActiveStatus();
  }, []);

  const GetChannelList = async () => {
    try {
      console.log("Fetching Channel List...");

      const response = await axios.get(`${apiUrlAdvAcc}/GetChannelList`);

      if (
        response.data.status === "Success" &&
        Array.isArray(response.data.channelList)
      ) {
        setChannels(response.data.channelList);
        setIsLoading(false);
      } else {
        console.log("Error fetching channels:", response);
        setChannels([]); // Prevent undefined errors
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching channels:", error);
      setChannels([]);
      setIsLoading(false);
    }
  };


  const [configDetailsByChannel, setConfigDetailsByChannel] = useState<string[]>([]);
  const [activeStatus, setActiveStatus] = useState<number[]>([]);
  const apiUrlOpAcc = useSelector((state: RootState) => state.authentication.operatorUrl);


  //We can add multiple active status here just by increaing the values in the key-value pair
  const processChannels = (data: any) => {
    const result: any = {};

    data.forEach((channel: any) => {
      // Check if any channel's status is 'active'
      const hasActive = channel.channels.some((config: any) => config.channelserver_app_status === 'active');
      result[channel.channel_id] = hasActive ? 1 : 0;
    });

    return result;
  };

  const GetOperatorChannelsListActiveStatus = async () => {
    try {
      console.log("Fetching Active Config details for each Channel...");

      const response = await axios.get(`${apiUrlOpAcc}/GetOperatorChannelsListActiveStatus?operatorId=${workspaceId}`);
      if (
        response.data.status === "Success"
      ) {
        setConfigDetailsByChannel(response.data.data);
        console.log("DATA :", response.data.data);
        const activeStatus = processChannels(response.data.data);
        console.log("Active Status by Channel ID:", activeStatus);
        setActiveStatus(activeStatus);

        setIsLoading(false);
      } else {
        console.log("Error fetching channels:", response);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching channels:", error);
      setIsLoading(false);
    }
  };


  const handleClose = () => {
    setIsDialogOpen(false);
  };

  const SubmitRequest = async (channel: string) => {
    console.log("Channel :", channel);
    try {
      const payload = {
        workspaceId: workspaceId || 0,
        campaignId: 0,
        campaignName: "UnKnown",
        statusMark: "Unread",
        notificationType: "RequestingPermission",
        notificationData: {
          Message: `${workspaceName}-(${emailId}) is requesting access to ${channel}`,
        },
        role: "Admin",
      };
      console.log("payload :", payload);
      const response = await axios.post(
        `${apiUrlAdvAcc}/CreateNotification`,
        payload
      );

      if (response.data.status === "Success") {
        toast.toast({
          title: "Success",
          description: "Request submitted successfully.",
        });
      }
    } catch (e) {
      console.log("Error :", e);
      toast.toast({
        title: "Error Occurred",
        description: "An unexpected error occurred. Please try again later.",
      });
    }
  };

  const handleRequestSubmit = async (channel: string) => {
    console.log("Request Data :", channel);
    SubmitRequest(channel);
    setIsDialogOpen(false);
  };

  return (
    <>
      {isLoading && (
        <div className="flex flex-col items-center justify-center h-[500px]">
          <CircularProgress color="primary" />
        </div>
      )}

      <div className="flex flex-wrap gap-4 p-2 w-full">
        {/* Sort the channels so available ones appear first */}
        {[...channels]
          .map((ch, idx) => (
            <Card
              key={idx}
              className={`w-[250px] p-[30px] relative cursor-pointer border ${selectedChannel === ch.channel_name
                ? "border-gray-300"
                : "border-gray-300"
                }`}
              onClick={() => {
                debugger

                setSelectedChannel(ch.channel_name);
                const url = `/operatorNavbar/${ch.channel_name?.toLowerCase()}`;
                console.log("Navigating to:", url);
                navigate(url, {
                  state: {
                    channelName: ch.channel_name,
                    channelId: ch.channel_id, // example if you want to send more data
                  },
                });


              }}
            >
              {/* Content aligned to the left */}
              <div className="flex w-full">
                <div>
                  <h3 className="font-semibold font-[14px] text-[#020617] text-left flex w-full mb-2">
                    {ch.channel_name}
                  </h3>
                </div>

                {/* Check Icon on the top right */}
                <div className="flex w-full justify-end absolute right-7 mt-1">
                  {activeStatus[ch.channel_id] === 1 ? (
                    <CheckIcon className="text-[#00A305] w-4 h-4 rounded-full border border-green-600" />
                  ) : (
                    <Cross1Icon className="text-[#D10000] w-4 h-4 rounded-full border border-red-500" />
                  )}
                </div>
              </div>

              <p className="mt-2 text-[#64748B] font-normal text-[12px] h-[68px] text-left w-full">
                {ch.channel_description}
              </p>
            </Card>
          ))}

        <Toaster />

        {/* Access Permission Dialog */}
        <Dialog open={isdialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogContent className="p-6 mx-auto">
            <DialogHeader>
              <DialogTitle className="text-18px font-semibold text-[#09090B]">
                Access Permission Required
              </DialogTitle>
              <DialogDescription className="text-14px font-medium text-[#71717A] mt-2">
                Access to this channel requires approval from an administrator.
                Would you like to submit a request for access?
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-end gap-4 flex-wrap">
              <Button
                className="px-4 py-2 w-auto"
                variant="outline"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className="px-4 py-2 w-auto text-[#FAFAFA] bg-[#3A85F7]"
                onClick={() => handleRequestSubmit(selectedChannel)}
              >
                Submit
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default OperatorChannelList;
